import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Megaphone, Send } from 'lucide-react';
import { api } from '../lib/api';
import { Button } from './ui/button';

const AUD = [{ v: 'all', l: 'Tous' }, { v: 'buyer', l: 'Acheteurs' }, { v: 'seller', l: 'Boutiques' }];

export const BroadcastPanel = () => {
  const [subject, setSubject] = useState('Nouveau : ajoutez vos photos depuis votre galerie');
  const [message, setMessage] = useState("Bonne nouvelle ! Vous pouvez désormais ajouter vos photos de produits et de boutique directement depuis la galerie de votre téléphone (y compris les photos iPhone), sans passer par l'appareil photo. Plusieurs photos à la fois, redimensionnées automatiquement.\nEt pour les prix et le stock : plus de zéro à effacer, tapez directement le nombre souhaité.\nBonnes ventes sur JOTALY !");
  const [audience, setAudience] = useState('all');
  const [ch, setCh] = useState({ email: true, sms: true, push: true });
  const [busy, setBusy] = useState(false);
  const [history, setHistory] = useState([]);

  const load = () => api.get('/admin/broadcasts').then(({ data }) => setHistory(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const send = async () => {
    if (!window.confirm(`Envoyer « ${subject} » à ${AUD.find((a) => a.v === audience).l.toLowerCase()} ?`)) return;
    setBusy(true);
    try {
      const { data } = await api.post('/admin/broadcast', { subject, message, audience, ...ch });
      toast.success(`Envoyé : ${data.emailed} e-mails, ${data.sms} SMS, ${data.notified} notifications`);
      setSubject(''); setMessage(''); load();
    } catch (e) { toast.error(e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || 'Erreur'); }
    setBusy(false);
  };

  const cls = 'w-full px-3 py-2 rounded-xl bg-slate-900/60 border border-slate-800 focus:border-[#FFD400] outline-none text-sm';
  return (
    <section className="card-elev rounded-2xl p-5" data-testid="broadcast-panel">
      <h2 className="font-display text-xl font-bold flex items-center gap-2 mb-1"><Megaphone className="h-5 w-5 text-[#FFD400]" />Message à mes utilisateurs</h2>
      <p className="text-sm text-slate-400 mb-4">Rédigez votre propre annonce : e-mail + SMS (comptes sans e-mail) + notification et push dans l'appli.</p>
      <div className="grid md:grid-cols-[1fr_auto] gap-3">
        <div className="space-y-3">
          <input data-testid="broadcast-subject" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Titre (ex : Nouveauté sur JOTALY)" className={cls} maxLength={120} />
          <textarea data-testid="broadcast-message" value={message} onChange={(e) => setMessage(e.target.value)} rows={5} placeholder="Votre message…" className={cls} maxLength={2000} />
        </div>
        <div className="space-y-3 md:w-56">
          <div className="flex flex-wrap gap-1">
            {AUD.map((a) => (
              <button key={a.v} type="button" data-testid={`broadcast-aud-${a.v}`} onClick={() => setAudience(a.v)}
                className={`px-3 py-1.5 text-xs rounded-full border ${audience === a.v ? 'bg-[#FFD400] border-[#FFD400] text-black font-bold' : 'border-slate-800 text-slate-400'}`}>{a.l}</button>
            ))}
          </div>
          {['email', 'sms', 'push'].map((k) => (
            <label key={k} className="flex items-center gap-2 text-sm text-slate-300">
              <input type="checkbox" data-testid={`broadcast-ch-${k}`} checked={ch[k]} onChange={(e) => setCh({ ...ch, [k]: e.target.checked })} className="accent-[#FFD400]" />
              {k === 'email' ? 'E-mail' : k === 'sms' ? 'SMS (sans e-mail)' : 'Push'}
            </label>
          ))}
          <Button data-testid="broadcast-send-btn" disabled={busy || subject.trim().length < 3 || message.trim().length < 5} onClick={send} className="btn-yellow font-bold w-full">
            <Send className="h-4 w-4 mr-1" />{busy ? 'Envoi…' : 'Envoyer'}
          </Button>
        </div>
      </div>
      {history.length > 0 && (
        <div className="mt-4 text-xs text-slate-400 space-y-1" data-testid="broadcast-history">
          {history.slice(0, 5).map((h) => (
            <div key={h.broadcast_id} className="flex justify-between gap-3 border-t border-slate-800/70 pt-1">
              <span className="truncate text-slate-300">{h.subject}</span>
              <span className="shrink-0">{new Date(h.created_at).toLocaleDateString()} · {h.emailed} e-mails · {h.sms} SMS · {h.notified} notifs</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
